module.exports = __webpack_public_path__ + "static/media/early_snow.69f857c9.jpg";